export const ROUTE = {
  signIn: '/signin',
  signUp: '/signup',
  login: '/login',
  profileStatus: '/status',
  complateProfileRoot: '/complete-profile',
  complateProfileStep1: 'step1',
  complateProfileStep2: 'step2',
  complateProfileStep3: 'step3',
  complateProfileStep4: 'step4',
};
